module.exports = __webpack_public_path__ + "img/MSENG3_Cover.c351015b.jpg";